/* Royal · Bed deal, site-wide (2026-11-02, White Friday; user: "make sure the discount applies site wide, not only
   on the Build your bed page"). Before this it applied only to pieces added from Build your bed (_bb property).
   Any cart, however the pieces got there (product page, quick view, Build your bed, cart drawer):
     - at least 1 duvet cover + 1 sheet set                  -> PART (10%)
     - at least 1 duvet cover + 1 sheet set + 1 Royal Duvet  -> FULL (20%)
   Extra pieces don't cancel it (user, 2026-11-02: "a second item doesn't waste the discount; 2 sheets and a duvet
   cover get 10%"). The code takes the percentage off every duvet cover, sheet set and duvet in the cart.
   Kids' sets don't count (the codes leave the kids collection out). Covers and sheets are told apart by handle
   (…duvet-cover-set…, …sheet-set…), because product_type is translated on /ar; kids and duvet product ids come from
   window.RoyalBedDealData, printed by layout/theme.liquid. Other codes the shopper entered are left alone.
   The codes live in Shopify admin (Discounts): BED10 / BED20, percentage off the Duvet Covers, Sheets and Duvets
   collections, minimum 3 items for BED20. Keep the names below in step with them.
   When it runs: on every page load, a moment after any cart change made with fetch (product form, quick view,
   cards, drawer quantities), and right before the cart drawer or cart page goes to checkout. */
(function () {
  if (window.RoyalBedDeal) return;
  var FULL = 'BED20-7QK4X', PART = 'BED10-7QK4X', OURS = [FULL, PART];
  var data = window.RoyalBedDealData || {}, kids = data.kids || [], duvets = data.duvets || [];
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function post(path, body) {
    return nativeFetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* which of our codes this cart has earned, or '' */
  function want(cart) {
    var n = { c: 0, s: 0, d: 0 };
    (cart.items || []).forEach(function (it) {
      var id = it.product_id, h = String(it.handle || '');
      if (kids.indexOf(id) > -1) return;
      if (duvets.indexOf(id) > -1) n.d += it.quantity;
      else if (h.indexOf('duvet-cover-set') > -1) n.c += it.quantity;
      else if (h.indexOf('sheet-set') > -1) n.s += it.quantity;
    });
    if (!n.c || !n.s) return '';
    return n.d ? FULL : PART;
  }

  /* the cart sections on this page that show totals: the drawer and, on /cart, the cart page */
  function targets() {
    var list = [];
    ['cart-drawer-items', 'cart-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (!el || typeof el.getSectionsToRender !== 'function') return;
      try { el.getSectionsToRender().forEach(function (s) { if (document.getElementById(s.id)) list.push(s); }); } catch (e) {}
    });
    return list;
  }
  function paint(list, res) {
    if (!res || !res.sections) return;
    list.forEach(function (s) {
      var html = res.sections[s.section], host = document.getElementById(s.id);
      if (!html || !host) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      var dst = host.querySelector(s.selector) || host;
      if (src) dst.innerHTML = src.innerHTML;
    });
  }

  var running = null, again = false;
  /* opts.render: return the drawer's sections so the caller can open the drawer with them (Build your bed's button);
     opts.force: post even when the codes are already right (so the caller always gets fresh sections) */
  function sync(opts) {
    opts = opts || {};
    if (!nativeFetch) return Promise.resolve(null);
    if (running && !opts.render) { again = true; return running; }
    var p = nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = (cart.discount_codes || []).map(function (d) { return d.code; });
        var keep = cur.filter(function (c) { return OURS.indexOf(String(c).toUpperCase()) < 0; });
        var w = want(cart), next = w ? keep.concat(w) : keep;
        if (!opts.force && next.join(',').toUpperCase() === cur.join(',').toUpperCase()) return null;
        var list = opts.render ? [] : targets();
        var body = { discount: next.join(',') };
        var ids = opts.render ? ['cart-drawer', 'cart-icon-bubble'] : list.map(function (s) { return s.section; });
        if (ids.length) { body.sections = ids; body.sections_url = window.location.pathname; }
        return post('cart/update.js', body).then(function (res) { if (!opts.render) paint(list, res); return res; });
      });
    if (!opts.render) {
      running = p;
      p.catch(function () {}).then(function () { running = null; if (again) { again = false; sync(); } });
    }
    return p;
  }

  window.RoyalBedDeal = { FULL: FULL, PART: PART, want: want, sync: sync };

  /* every cart change made with fetch anywhere on the site is checked a moment later, after the theme has redrawn
     the drawer, so the corrected totals are the ones left on screen (our own calls use nativeFetch, so no loop) */
  if (nativeFetch) {
    var timer = null;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = nativeFetch(input, init);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        res.then(function () { clearTimeout(timer); timer = setTimeout(sync, 400); }, function () {});
      }
      return res;
    };
  }

  /* checkout from the cart drawer or the cart page: put the right code on first, then go on */
  document.addEventListener('submit', function (e) {
    var form = e.target, btn = e.submitter;
    if (!form || !btn || btn.getAttribute('name') !== 'checkout' || form.hasAttribute('data-bed-synced')) return;
    e.preventDefault();
    var go = function () {
      form.setAttribute('data-bed-synced', '');
      var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = btn.value || '';
      form.appendChild(h);
      form.submit();
    };
    sync({ force: false }).then(go, go);
  }, true);

  sync();
})();
